import { endOfDay, startOfDay, subDays } from 'date-fns';

import { AllowedActions } from './model/allowed-actions.model';
import { FilterOptions } from './model/filter-options.model';
import { OrderBy } from './model/order-by.model';
import { TranscriptBehaviourView } from './model/transcript-behaviour-view.model';
import { TranscriptCategories } from './model/transcript-categories.model';

export interface TranscriptSummaryState {
    pending: {
        reload?: boolean;
        deleteTranscript?: boolean;
    };

    allowedActions?: AllowedActions;

    /**
     * static order:
     * - active-behaviour
     * - draft-behaviour
     * - closed-behaviour
     * - non-associated-transcripts
     */
    transcriptsId?: number;
    transcriptCategories?: TranscriptCategories[];
    filteredTranscriptCategories?: TranscriptCategories[];

    filterOpts: FilterOptions;
    orderBy: OrderBy;

    filterParticipants?: string[];
    filterBehaviours?: TranscriptBehaviourView[];
    filterSubBehaviours?: TranscriptBehaviourView[];
}

export const defaultState = (): TranscriptSummaryState => ({
    pending: {},
    filterOpts: {
        dateRange: {
            from: startOfDay(subDays(new Date(), 90)),
            to: endOfDay(new Date()),
        },
    },
    orderBy: OrderBy.BY_DATE_MOST_RECENT,
});
